<template>
  <span
    @click="onClick"
    class="menu-button d-flex justify-content-center align-items-center m-1 rounded clickable"
    :class="{ 'is-disabled': disabled }"
    v-b-popover.hover="popoverConfig(title)"
  >
    <!-- <font-awesome-icon :icon="icon" v-if="icon" class="menu-icon-fa" /> -->
    <i v-if="icon" :class="`mdi mdi-${icon}`" class="menu-icon-mdi"></i>
    <img :src="require(`@/assets/images/icons/${customIcon}.svg`)" class="menu-icon-img" v-else>
  </span>
</template>

<script>
export default {
  props: {
    icon: String,
    customIcon: String,
    title: String,
    disabled: Boolean,
    disableTooltip: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    onClick () {
      if (!this.disabled) {
        this.$emit('click')
      }
    },
    popoverConfig (title) {
      if (this.disableTooltip) { return false }
      return {
        placement: 'top',
        boundary: 'viewport',
        content: title
      }
    }
  }
}
</script>

<style scoped>
.menu-button {
  height: 35px;
  width: 35px;
  flex: 0 0 35px;
  padding: 0;
  transition: ease all 0.4s;
}

.menu-button:hover {
  background-color: #dbdbdb;
}

.menu-button.is-disabled {
  color: #c2c2c2;
}

.menu-button.is-disabled:hover {
  cursor: not-allowed;
  pointer-events: all !important;
}

.menu-icon-img {
  width: 0.95rem;
}

.menu-icon-fa {
  vertical-align: middle;
  width: 1.1rem;
  height: 1.1rem;
}

.menu-icon-mdi {
  vertical-align: middle;
  font-size: 1.1rem;
  line-height: 1;
}
</style>
